import { FC, ReactNode } from 'react';

export interface ShowcaseItemProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export const ShowcaseItem: FC<ShowcaseItemProps> = ({ title, children, className = '' }) => (
  <div className={`mb-3 p-3 rounded ${className}`} style={{ border: '1px solid var(--theme-BorderDefault)' }}>
    <h6 className='text-ThemeTextLight mb-3'>{title}</h6>
    <div className='d-flex align-items-center flex-wrap gap-2'>{children}</div>
  </div>
);

export const ShowcaseSection: FC<ShowcaseItemProps> = ({ title, children }) => (
  <div className='mb-5 p-3 rounded' style={{ border: '1px solid var(--theme-BorderDefault)' }}>
    <h3 className='mb-4 text-primary border-bottom pb-2'>{title}</h3>
    {children}
  </div>
);
